import React from 'react';
import classNames from 'classnames';
import goldlog from '../log';
import Icon from '@alife/next/lib/icon';

import './index.scss';

const { createI18N } = window['IcbuIM'].lib.I18N;
const I18N = createI18N({
  namespace: 'onepage.ma.pwa'
});

class PWA extends React.Component {
  constructor(props) {
    super(props);
    this.addToHome = this.addToHome.bind(this);
    this.shouldShowAddButton = this.shouldShowAddButton.bind(this);
    this.state = {
      successfullyInstalled: false,
      readyToAdd: false,
      acceptedInstall: false,
      declinedInstall: false,
      close: false,
    };
  }

  componentDidMount() {
    // check if user is already running app from home screen
    if (window.matchMedia('(display-mode: standalone)').matches) {
      goldlog('usePWA');
      this.setState({
          successfullyInstalled: true,
      });
    } else {
      window.addEventListener('beforeinstallprompt', e => {
          // Prevent Chrome 67 and earlier from automatically showing the prompt
          e.preventDefault();
          // Stash the event so it can be triggered later.
          // @ts-ignore
          window.deferredPrompt = e;
          this.setState({
              readyToAdd: true,
          });
      });
      // this event fires only when app is installed
      window.addEventListener('appinstalled', evt => {
          goldlog('installPWASuc');
          this.setState({
            successfullyInstalled: true,
          });
      });
    }
  }

  addToHome() {
    let { deferredPrompt } = window;
    if (deferredPrompt) {
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
                goldlog('installPWA');
                this.setState({
                  acceptedInstall: true
                });
            } else {
                goldlog('declinePWA');
                this.setState({
                  declinedInstall: true,
                });
            }
            deferredPrompt = null;
        });
    }
  }

  shouldShowAddButton() {
    let shouldShow =
      this.state.readyToAdd &&
      !this.state.successfullyInstalled &&
      !this.state.acceptedInstall &&
      !this.state.declinedInstall &&
      !this.state.close;
    return shouldShow;
  }

  render() {
    const isBuyer = this.props.version === 'buyer';
    const logoUrl = isBuyer ? 'https://img.alicdn.com/tfs/TB1uArtRSrqK1RjSZK9XXXyypXa-128-128.png': 'https://img.alicdn.com/tfs/TB1tSLzb1T2gK0jSZFvXXXnFXXa-128-128.png';
    return (
      <div className='pwa-addHome'>
        {this.shouldShowAddButton() ? (
          <div className="content">
            <img src={logoUrl} className="icon"/>
            <div className="tip">
              <div dangerouslySetInnerHTML={{__html: I18N.get('title')}}></div>
              <div className="sub-tip">{I18N.get('subtitle')}</div>
            </div>
            <button className="add-action" onClick={this.addToHome}>{I18N.get('add')}</button>
            <span className="close" onClick={() => { this.setState({ close: true } ); }}><Icon type="close" size="small"/></span>
          </div>
        ) : null}
      </div>
    );
  }
}

export default PWA;